import React, { useEffect } from "react";
import Layout from "../layout";
import MainBanner from "./page-main-banner-one-column";
import JobInfo from "./job-info";
import FormSectionCareer from '../common/templates/form/form-section-career';
import SEO from '../seo';
import {
  jobInfoObj
} from './career-details-constants';
import { graphql } from "gatsby";

export const careerDetailsQuery = graphql`
  query ($id: String) {
    wordpressWpCareer(id: {eq: $id}) {
      acf {
        icon{
          source_url
        }
      icon_path
      job_location
      job_type
    }
    content
    date(fromNow: true)
    icon
    title
    type
    career_category
    }
  }`;

function CareerDetailsPage(props) {
  useEffect(()=>{
    console.log(props)
  })
  return (
    <Layout addBodyClass="career-details-page-template transparent-header">
      <SEO description={`${props.data.wordpressWpCareer.title} - Vacancy at Rapidops`}
        meta={[{ name: "charSet", content: "utf-8" }]}
        title={props.data.wordpressWpCareer.title} />
      <MainBanner data={props.data.wordpressWpCareer} />
      <JobInfo data={jobInfoObj} content={props.data.wordpressWpCareer.content} />
      {/* <CareerMission /> */}
      <FormSectionCareer className="site-footer-form" jobType={props.data.wordpressWpCareer.title} W/>
    </Layout>
  );
}

export default CareerDetailsPage;